<template>
  <div class="form-check">
    <label :class="[
      'form-label',
      'form-check-label',
      {
        'form-label--disabled': disabled,
        'text-danger': !!v$.$error
      }
    ]">
      <input
        v-bind="$attrs"
        v-model="model"
        v-focus="hasFocus"
        :class="['form-check-input', { 'is-invalid': v$.$error }]"
        :aria-invalid="v$.$error ? 'true' : 'false'"
        :aria-required="required"
        :disabled="disabled"
        type="checkbox"
        @blur="v$.$touch()"
      />
      <slot>{{ label }}</slot>
      <span v-if="required" class="text-danger">*</span>
    </label>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import focusable from '@ssi/vue-common/src/mixins/focusable';
import { required } from '../../validators';

export default {
  setup(props) {
    return {
      v$: useVuelidate(
        computed(() => ({
          modelValue: {
            required: {
              $validator: val => !props.required || val === true,
              $message: required.$message
            }
          }
        })),
        computed(() => ({ modelValue: props.modelValue }))
      )
    };
  },

  inheritAttrs: false,

  mixins: [focusable],

  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },

    label: String,

    required: {
      type: Boolean,
      default: () => false
    },

    modelValue: Boolean
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get: ({ modelValue }) => modelValue,

      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  }
};
</script>
